import { DoctorSchedule } from 'interfaces/clinicSchedule';
import moment from 'moment';

const formatScheduleTime = ({ isFormatWithoutA, start, end }: any) => {
  const isMinuteStartEmpty = start.substring(3, 5) === '00';
  const isMinuteEndEmpty = end.substring(3, 5) === '00';

  if (isFormatWithoutA) {
    return (
      moment(start, 'hh:mmA').format(isMinuteStartEmpty ? 'h' : 'h:mm') +
      '-' +
      moment(end, 'hh:mmA').format(isMinuteEndEmpty ? 'h' : 'h:mm')
    );
  }

  return (
    moment(start, 'hh:mmA').format(isMinuteStartEmpty ? 'hA' : 'h:mmA') +
    '-' +
    moment(end, 'hh:mmA').format(isMinuteEndEmpty ? 'hA' : 'h:mmA')
  );
};

const getPractitionerWorkingHour = ({
  practitionerId,
  workingHourPractitioners,
  isFormatWithoutA,
  operatoryId,
}: {
  practitionerId?: string;
  workingHourPractitioners?: (DoctorSchedule & {
    name: string;
    syncedWorkingHour?: any;
  })[];
  isFormatWithoutA?: boolean;
  operatoryId?: string;
}) => {
  if (!practitionerId) return '';

  const practitioner = workingHourPractitioners?.find(
    (item) => item.id === practitionerId
  );

  if (!practitioner || !practitioner.workingHour) return '';

  if (
    operatoryId &&
    practitioner.syncedWorkingHour &&
    practitioner.syncedWorkingHour.length !== 0
  ) {
    const syncedWorkingHourByOperatoryId =
      practitioner.syncedWorkingHour.filter(
        (item: any) => item.operatoryId === operatoryId
      );

    const result = syncedWorkingHourByOperatoryId
      .map((item: any) =>
        formatScheduleTime({
          isFormatWithoutA,
          start: item.start,
          end: item.end,
        })
      )
      .join(', ');

    return result;
  }

  const start = practitioner.workingHour.start;
  const end = practitioner.workingHour.end;

  if (!start || !end) return 'Day Off';

  const result = formatScheduleTime({
    isFormatWithoutA,
    start,
    end,
  });

  return result;
};

export default getPractitionerWorkingHour;
